export function isSessionError(errorMessage: string): boolean {
  const lowerCaseMessage = errorMessage.toLowerCase();
  return lowerCaseMessage.includes('sessionnotapprovederror') || lowerCaseMessage.includes('session not found');
}
